import {identity, ifElse, propEq, whereEq} from 'ramda';
import {getFileData, uploadFileWithData} from '@sinclair-digital/v2-content-service/lib/file';
import {fetchJsonV1} from '@sinclair-digital/v2-content-service/lib/fetch';

const isVideo = propEq('mediaType', 'video');
const mediaReady = ifElse(isVideo, propEq('videoStatus', 'READY'), propEq('mediaStatus', 'READY'));

// fetchMediaMetaData :: object -> Promise<MediaItem>
const fetchMediaMetadata = ({uuid}) =>
  fetchJsonV1(`/platform/media/summary`, {method: 'POST', body: JSON.stringify([uuid])})
    .then(foundMedia => foundMedia.find(whereEq({uuid})) || Promise.reject(new Error(`Uploaded media was lost`)));

// pollMediaMetadata :: (Object, (Error -> ()), (a -> ()), Int?) -> ()
const pollMediaMetadata = (pendingMediaItem, rej, res, retries = 0) => {
  fetchMediaMetadata(pendingMediaItem)
    .then(mediaItem => {
      if (mediaReady(mediaItem)) {
        res(mediaItem);
      } else {
        setTimeout(
          () => pollMediaMetadata(pendingMediaItem, rej, res, retries + 1),
          1000 * retries // linear backoff on retries
        );
      }
    })
    .catch(rej);
};

const uploadUrl = `/platform/media/`;
// uploadFile :: File -> Promise MediaItem Error
export const uploadFile = (file, captionFilter = identity) =>
  getFileData(file)
    .then(captionFilter)
    .then(uploadFileWithData(uploadUrl, file))
    .then(([pendingMediaItem]) => pendingMediaItem
      ? new Promise((res, rej) => pollMediaMetadata(pendingMediaItem, rej, res))
      : Promise.reject(new Error('Upload failed to return suitable metadata'))
    );
